import { SxProps } from '@mui/material';

export const wrapCellStyle: SxProps = {
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  lineHeight: '1.2',
  whiteSpace: 'normal',
};
